import { Authenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

const Login = () => {
  const navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState(null); // ✅ Track user state

  useEffect(() => {
    if (loggedInUser) {
      navigate("/file-uploader"); // ✅ Redirect after login
    }
  }, [loggedInUser, navigate]);

  return (
    <Authenticator>
      {({ signOut, user }) => {
        setLoggedInUser(user); // ✅ Update state when user logs in
        return (
          <div>
          </div>
        );
      }}
    </Authenticator>
  );
};

export default Login;
